const precision = 4 
/**
 * Round Float Number
 * @param {Number}  number float number
 * @return {Number}  Float number with decimals to 4 digits
 */
export function roundFloat(number) {
	return Number(Number.parseFloat(number).toFixed(precision));
}